<!-- <div class="map-container">
	<div class="titleContainer">
		<h2>Jott Responses by Location</h2>
	</div>
	<portals-loading [showIf]="formLoading">
		<div class="mcontainer" fxLayout="row" fxLayout.lt-md="column">
			<button [disableRipple]="true" #scrollTrigger hidden="true" appScrollAnchor="mapEnd">Schedule</button>
			<div class="map-container" fxFlex="50" fxFlex.lt-md>
				<agm-map [latitude]="40.712776" [longitude]="-74.005974" [zoom]="4" [style.height.px]="400" (mapReady)="onMapLoad($event)"></agm-map>
			</div>
			<div class="chart-container px-12" fxFlex>
				<div *ngFor="let item of locationData" class="chart-item">
					<div class="city-info">
						<span class="city-name">{{ item.city }}</span>
						<span *ngIf="item.country" class="country">{{ ' ' }}({{ item.country }})</span>
					</div>
					<div class="bar-container">
						<div class="bar" [style.width.%]="getBarWidth(item.count)">
							<span [class.outside-bar]="getBarWidth(item.count) < 20">{{ item.count }}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</portals-loading>
</div>
<div appScrollSection="mapEnd"></div> -->
<div class="p-0 flex flex-col rounded-md bg-portals-theme-surface border border-portals-primary-200">
	<div class="titleContainer">
		<h2 class="text-portals-theme-on-primary text-base m-0">Jott Responses by Location</h2>
	</div>
	<portals-loading [showIf]="formLoading">
		<div class="flex flex-col laptop:flex-row w-full tablet:items-start mobile:items-start">
			<button [disableRipple]="true" #scrollTrigger hidden="true" appScrollAnchor="mapEnd" class="sr-only">Schedule</button>
			<div class="h-[400px] laptop:h-[400px] desktop:h-[400px] industrial:h-[400px] tablet:w-full mobile:w-full laptop:w-3/5 desktop:w-2/3 industrial:w-3/4">
				<agm-map [latitude]="40.712776" [longitude]="-74.005974" [zoom]="4" class="w-full h-full" (mapReady)="onMapLoad($event)"></agm-map>
			</div>
			<div class="font-portals w-full laptop:w-2/5 desktop:w-1/3 industrial:w-1/4 py-5 laptop:py-10 px-4">
				<div class="max-h-[600px] laptop:max-h-[500px] desktop:max-h-[600px] industrial:max-h-[700px] overflow-y-auto">
					<div *ngFor="let item of locationData" class="flex items-center mb-2.5">
						<div class="laptop:w-[150px] desktop:w-[180px] industrial:w-[200px] tablet:w-4/12 mobile:w-6/12 text-right pr-2.5 whitespace-nowrap overflow-hidden overflow-ellipsis">
							<span class="font-bold text-portals-theme-primary-text">{{ item.city }}</span>
							<span *ngIf="item.country" class="text-xs text-portals-primary-400 ml-1">({{ item.country }})</span>
						</div>
						<div class="flex-grow laptop:max-w-[250px] desktop:max-w-[300px] industrial:max-w-[350px] tablet:max-w-7/12 bg-portals-theme-highlight h-[30px] relative laptop:max-w-[400px]">
							<div class="bg-portals-primary-900 h-full flex items-center px-1.5 min-w-[30px]" [style.width.%]="getBarWidth(item.count)">
								<span class="text-portals-theme-on-primary font-bold" [class.outside-bar]="getBarWidth(item.count) < 10">{{ item.count }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</portals-loading>
</div>
<div appScrollSection="mapEnd"></div>

<style>
	.outside-bar {
		@apply text-portals-primary-900 absolute left-full ml-1.5;
	}
</style>
